import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { TransportListIconName } from 'src/app/pages/custom-route/interfaces/custom-route.response';

@Component({
  selector: 'app-transport-icon',
  standalone: true,
  imports: [
    
  ],
  templateUrl: './transport-icon.component.html',
  styleUrls: ['./transport-icon.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TransportIconComponent {
  public iconName = input<TransportListIconName>();
}
